import { theme } from 'aimo-ui';
import { VehicleIconWrapper } from 'components/common/VehicleAvatar';
import Icon from 'components/icons/Icon';
import FeatureFlagsContext from 'context/FeatureFlagsContext';
import React, { useContext, useMemo } from 'react';
import { ChargingSession, ParkingSession } from 'types/generatedSchemaTypes';
import { showFeatureFlag } from 'utils/featureFlagUtils';
import { getLocationIconType, locationIcon } from 'utils/parkUtils';

type OngoingSessionAvatarProps = {
  session: ParkingSession | ChargingSession;
};

const SessionAvatar = ({ session }: OngoingSessionAvatarProps) => {
  const {
    flags: { anpr },
  } = useContext(FeatureFlagsContext);
  const showCameraRecognition = showFeatureFlag(anpr);
  let icon;
  let color = theme.colors.gray100;

  const isPermit = useMemo(() => {
    return (
      session.__typename === 'ParkingSession' &&
      session.permitAllocations?.[0]?.permitApplies
    );
  }, [session]);

  const isCorporateAccount = useMemo(() => {
    return (
      session.__typename === 'ParkingSession' &&
      session.paymentType === 'CORPORATE_ACCOUNT'
    );
  }, [session]);

  const isCharging = useMemo(() => {
    return session.__typename === 'ChargingSession';
  }, [session]);

  if (isCorporateAccount) {
    icon = 'Business-Outlined';
  } else if (isPermit) {
    icon = 'Services-Outlined';
  } else {
    icon =
      locationIcon[
        getLocationIconType(
          session.parkZone?.locationType || 'OTHER',
          showCameraRecognition &&
            session.__typename === 'ParkingSession' &&
            session.type === 'ANPR',
          session.__typename === 'ChargingSession'
        )
      ];
    if (isCharging) {
      color = theme.colors.lightBg.green;
    }
  }

  return (
    <VehicleIconWrapper
      numericSize={theme.iconSizes.l}
      color={color}
      showBackground
      showBorder>
      <Icon
        name={icon}
        size="m"
        color={theme.colors.black}
        testID={`ongoing-session-avatar-${icon}`}
      />
    </VehicleIconWrapper>
  );
};

export default SessionAvatar;
